import { Toast, ToastProps } from "primereact/toast";
import successToastIcon from "asset/img/icons/success_toast.svg";
import smallCloseIcon from "asset/img/icons/small-close.svg";
import checkInfo from "asset/img/icons/toast-info.svg";
import checkFail from "asset/img/icons/toast-error.svg";
import checkWarning from "asset/img/icons/toast-alert.svg";
import React, { useImperativeHandle, useRef, useEffect, useState } from "react";
import { generateClasses } from "util/Util";
import { INPUT_ERROR_TYPE } from "util/Constant";
import { TOAST_STYLES } from "asset/base-theme";
import Text from "component/Text/Text";
import BaseToast from "component/base/BaseToast/BaseToast";

export interface IToastProps extends ToastProps {
  message: any;
  className?: string;
  variantType?: string;
  style?: object;
  toastLife?: number;
}

const ToastCustom = React.forwardRef((props: any, ref: any) => {
  const toastRef = useRef<Toast>(null);

  const getClassNames = (overrideVariantType?: string) => {
    const styleObject = {
      ...TOAST_STYLES,
      overrideStyle: props.styleObj,
      overrideClasses: props.className,
      isDisabled: props.disabled,
      applyErrorStyle: props.validation && props.errorType == INPUT_ERROR_TYPE.BORDER,
      removeStyleProperty: [],
      removeClasses: [],
    };

    return generateClasses(styleObject, overrideVariantType ?? props.variantType);
  };

  const onClose = () => {
    if (toastRef.current) {
      toastRef.current.clear();
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      setTimeout(() => {
        if (document.visibilityState === "visible") onClose();
        else handleVisibilityChange();
      }, 5000);
    }
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    showFunction(
      overriddenMessage?: string,
      overriddenComponent?: React.ReactNode,
      overrideVariantType?: string,
      sticky?: boolean
    ) {
      let checkIcon, closeIcon;
      const variantType = overrideVariantType ?? props.variantType;
      switch (variantType) {
        case "SECONDARY":
          checkIcon = checkInfo;
          closeIcon = smallCloseIcon;
          break;
        case "TERTIARY":
          checkIcon = checkWarning;
          closeIcon = smallCloseIcon;
          break;
        case "QUATERNARY":
          checkIcon = checkFail;
          closeIcon = smallCloseIcon;
          break;
        default:
          checkIcon = successToastIcon;
          closeIcon = smallCloseIcon;
      }

      if (toastRef.current) {
        // Clear any existing timers

        const toastLife = props.toastLife || 5000;

        toastRef.current.show({
          life: sticky ? undefined : toastLife,
          sticky: !!sticky,
          summary: (
            <div className="flex items-center justify-between">
              <div className="flex items-center justify-between gap-3 overflow-hidden">
                <img className="h-6 w-6 shrink-0" src={checkIcon} alt="icon" />

                {overriddenComponent ? (
                  overriddenComponent
                ) : (
                  <Text className="w-full text-wrap" label={overriddenMessage ?? props.message} />
                )}
              </div>
              <button
                className="shrink-0"
                onClick={() => {
                  onClose();
                  if (props.onRemove) {
                    props.onRemove();
                  }
                }}
              >
                <img src={closeIcon} alt="X" className="h-6 w-6 cursor-pointer" />
              </button>
            </div>
          ),
          contentClassName: getClassNames(overrideVariantType) + "",
        });
        handleVisibilityChange();
      }
    },
    onClose,
  }));

  const { position } = props;

  return <BaseToast position={position} ref={toastRef} {...props} />;
});

// Memoization
export default React.memo(ToastCustom);
// redux wiring
